<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

      <a-form-model-item prop="couponId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('礼品券')}}<template slot="title">{{$t('礼品券')}}</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.couponId" placeholder="请选择类型">
          <a-select-option v-for="(item, index) in couponList" :value="item.id" :key="index">
            {{ item.couponName}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="price" >
        <span slot="label" >
          <a-tooltip>
            {{$t('价值')}}<template slot="title">{{$t('价值')}}</template>
          </a-tooltip>
        </span>
        <a-input type="number" :min="1" v-model="form.price"  :placeholder="$t('通用.输入.请输入')+$t('价值')" />
      </a-form-model-item>
      <a-form-model-item prop="prizeNum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('奖品数量')}}<template slot="title">{{$t('奖品数量')}}</template>
          </a-tooltip>
        </span>
        <a-input type="number" :min="1" v-model="form.prizeNum"  :placeholder="$t('通用.输入.请输入')+$t('奖品数量')" />
      </a-form-model-item>
      <a-form-model-item prop="openTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('开奖时间(秒)')}}<template slot="title">{{$t('开奖时间(秒)')}}</template>
          </a-tooltip>
        </span>
        <a-input type="number" :min="1" v-model="form.openTime"  :placeholder="$t('通用.输入.请输入')+$t('开奖时间(秒)')" />
      </a-form-model-item>
<!--      <a-form-model-item prop="remark" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {liveGiftCouponList,addLottery} from "@/api/live/live";


export default {
  name: 'CreateFormLottery',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      couponList: [],
      // 表单参数
      form: {
        id: null,

        liveId: null,

        couponId: null,

        prizeNum: null,
        price: null,

        openTime: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        couponId: [
          { required: true, message: this.$t('中奖礼品券')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],   prizeNum: [
          { required: true, message: this.$t('中奖数量')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],  price: [
          { required: true, message: this.$t('价格')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ], openTime: [
          { required: true, message: this.$t('开奖时间  ')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        liveId: null,
        couponId: null,
        prizeNum: null,
        price: null,
        openTime: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      this.form.liveId = row.id
      this.open = true
      this.formTitle = this.$t('创建抽奖')
      liveGiftCouponList({"liveId":row.id}).then(response => {
        this.couponList = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
            message = this.$t('创建抽奖成功')
            addLottery(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
